<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid mb-5">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="schedule.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
        </div>

        <div class="p-fluid crm-schedule-form-hours">
          <label class="font-medium">График</label>
          <crm-table
            styleClass="mt-3 border-top-1 border-100"
            name="schedule.form"
            [values]="workDaysFields">
            <ng-template
              #rowTemplate
              let-field="item">
              <tr>
                <td>
                  {{ field[0] | translateWeekDays }}
                </td>
                <td>
                  <div class="crm-schedule-form-hours-field w-full">
                    <p-inputNumber
                      [min]="0"
                      [max]="24"
                      [showButtons]="true"
                      [(ngModel)]="field[1]"
                      (ngModelChange)="setWorkHours()"
                      class="w-full"></p-inputNumber>
                  </div>
                </td>
              </tr>
            </ng-template>
          </crm-table>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveSchedule()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteSchedule()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
